//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { ServiceConstants } from "utils/constants";
//#endregion
import { ApiClientInstance } from "utils/helpers";

/**
 * @deprecated This service is deprecated. Use useSupplierService hook instead.
 *
 * @see useSupplierService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const SupplierService = {
  //#region Supplier
  filter: (filter: ApiModels.IncomingInvoiceSupplierFilter) => {
    return ApiClientInstance(AuthEnums.AuthType.Company).IncomingInvoiceClient.GetSuppliers(filter);
  },

  searchSupplierByName: (searchStr: string) => {
    return SupplierService.filter({
      ...ServiceConstants.DefaultFilter,
      name: searchStr,
    } as ApiModels.IncomingInvoiceSupplierFilter).then((res) =>
      res.data.items
        ? res.data.items.map(
            (supplier): WintUtilsWebApi.SearchResult => ({ id: supplier.id.toString(), name: supplier.name ?? "" })
          )
        : []
    );
  },

  getSupplier: async (supplierId: number): Promise<ApiModels.IncomingInvoiceSupplierInfo> => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .IncomingInvoiceClient.GetSupplier(supplierId)
      .then((res) => res.data);
  },
};

export default SupplierService;
